// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2IKjT","dragIcon":"Choice_dragIcon__gnkgT","left":"Choice_left__2YTJt","input":"Choice_input__1uRO1"};